import React from 'react'
import { Box } from 'native-base'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import LocalizationContext from '../../context/LocalizationContext'
import Loading from '../../components/basic/Loading'
import ReservationList from '../../components/ReservationList'
import moment from 'moment'
import _ from 'lodash'

function ReservationListScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { navigation, reservationStore, route } = props
    const [isLoading, setIsLoading] = React.useState(true)

    const { productId, time } = route.params

    React.useEffect(() => {
        const componentDidMount = async () => {
            try {
                await reservationStore.listReservations(productId, time)
            }
            catch (e) {
                console.log(e)
            }
            setIsLoading(false)
        }

        componentDidMount()
    }, [navigation])


    const handleOnEndReached = async () => {
        try {
            console.log('oer')
        }
        catch (e) {
            console.log(e)
        }
    }
    if (isLoading) {
        return <Loading />
    }


    return (
        <ReservationList
            t={t}
            reservations={toJS(reservationStore.reservations)}
            onEndReached={() => handleOnEndReached()}
            onOrderPress={(_id) => { return navigation.push('OrderDetail', { orderId: _id }) }}
        />
    )
}

export default inject('reservationStore')(observer(ReservationListScreen))